exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.signin-warning[data-v-f43afc94] {\n  margin-bottom: 3rem;\n  text-align: center;\n}\n", "", {"version":3,"sources":["/home/gitlab-runner/builds/3bb37404/0/mkz/werner-frontend/src/components/app/authentication/signin/signin.css"],"names":[],"mappings":";AAAA;EACE,oBAAoB;EACpB,mBAAmB;CACpB","file":"signin.css","sourcesContent":[".signin-warning {\n  margin-bottom: 3rem;\n  text-align: center;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-f43afc94","scoped":true,"hasInlineConfig":false}!./src/components/app/authentication/signin/signin.css
// module id = 3iWI
// module chunks = 1